import { magellanClient } from '../../../infra/axios';
import type { SearchRequestDTO, SearchResponseDTO } from './dto';

export async function search(
  query: SearchRequestDTO,
): Promise<SearchResponseDTO> {
  const response = await magellanClient.get<SearchResponseDTO>('/search', {
    params: query,
  });
  return response.data;
}
